import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { PasteFromClipboardContent } from './pasteFromClipboardContent/PasteFromClipboardContent'

interface IProps {
  show: boolean
  onClose: () => void
  globalPartnerId: string
  fYear: number
}

export const PasteFromClipboard = ({ show, onClose, globalPartnerId, fYear }: IProps) => {
  const contentProps = useMemo(
    () => ({
      onClose,
      globalPartnerId,
      fYear,
    }),
    [onClose, fYear, globalPartnerId]
  )
  return (
    <ModalDialog
      onClose={onClose}
      show={show}
      size={'xs'}
      content={PasteFromClipboardContent}
      contentProps={contentProps}
    />
  )
}
